import { render, staticRenderFns } from "./ATMItemPerfect.vue?vue&type=template&id=143a6309&scoped=true"
import script from "./ATMItemPerfect.vue?vue&type=script&lang=ts"
export * from "./ATMItemPerfect.vue?vue&type=script&lang=ts"
import style0 from "./ATMItemPerfect.vue?vue&type=style&index=0&id=143a6309&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143a6309",
  null
  
)

export default component.exports